import { Call, PATH } from "../../../services/NetworkManager";
import {
  ListedBondsApiResponse,
  ListedBondDetailApiResponse,
  CashflowCalculateRequest,
  CashflowCalculateApiResponse,
  BondscannerPartnerInterest,
  DownsellingYieldRangeResponse,
} from "./bonds.types";

// Plain fetch — no auth headers, no personal data is sent.
export async function getListedBonds(): Promise<ListedBondsApiResponse> {
  try {
    const url = `${process.env.REACT_APP_BONDS_API_BASE_URL}/v1/issuer/ipc?size=200&bond_type=ALL_BONDS`;
    const response = await fetch(url, { method: "GET" });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching listed bonds:", error);
    throw error;
  }
}

// Fetches the full bondscanner ISIN config (all configured ISINs). Uses the
// authed NetworkManager client since bondscanner lives on the main API.
export async function getBondscannerIsinConfig(): Promise<DownsellingYieldRangeResponse> {
  return Call({ method: "get", path: PATH.bondscannerGetIsinConfig });
}

// Plain fetch — no auth headers, no personal data is sent.
export async function getListedBondDetail(
  id: string,
): Promise<ListedBondDetailApiResponse> {
  try {
    const url = `${process.env.REACT_APP_BONDS_API_BASE_URL}/v1/issuer/isins/${id}`;
    const response = await fetch(url, { method: "GET" });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching listed bond detail:", error);
    throw error;
  }
}

// Plain fetch — only Content-Type header, no auth/personal data.
export async function calculateCashflow(
  body: CashflowCalculateRequest,
): Promise<CashflowCalculateApiResponse> {
  try {
    const url = `${process.env.REACT_APP_BONDS_API_BASE_URL}/v1/cashflow/calculate`;
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error calculating cashflow:", error);
    throw error;
  }
}

// Captures the partner's downselling interest in Strapi (Bearer-token auth).
export async function submitBondscannerInterest(
  payload: BondscannerPartnerInterest,
): Promise<any> {
  try {
    const url = `${process.env.REACT_APP_STRAPI_API_ENDPOINT}/bondscanner-partner-interests`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: payload }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error submitting bondscanner interest:", error);
    throw error;
  }
}
